<template>
  <div class="titleBlockImg" style="width: 322px;height: 100%;">
    <el-carousel height="250px" :autoplay="false">
      <div>
        <el-carousel-item v-for="item in imageUrl" class="del" :key="item.id">
          <div class="del-icon" @click="delItem(item)">
            <i class="el-icon-delete"></i>
          </div>
          <el-upload :disabled="!updateRev" class="avatar-uploader" action="" :show-file-list="false"
            :before-upload="beforeAvatarUpload">
            <img :src="item.url" @click="getUpdateImgId(item.id)" class="avatar">
          </el-upload>
        </el-carousel-item>
      </div>

      <el-carousel-item v-if="addNewFile">
        <el-upload :disabled="!updateRev" class="avatar-uploader upLoadBorder" action="" :show-file-list="false"
          :before-upload="beforeAvatarUpload">
          <i class="el-icon-plus avatar-uploader-icon" @click="getUpdateImgId('')"></i>
        </el-upload>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>


<script>
import axios from 'axios'
export default {
  data() {
    return {
      imageUrl: [],
      upLoadDialog: false,
      upLoadProgress: 0,
      imgSwiper: "",
      updateImgId: "",
      addNewFile: false,
      updateRev: false,
    }
  },
  methods: {

    delItem(item) {
      const fileIds = [item.id]
      // return
      axios.post('/swift-file/icons/deleteFile', fileIds).then(res => {
        console.log(res);
        if (res.data.code == 200) {
          this.$message.success(res.data.message);
          this.getIconImg();
        }
      })
    },
    getUpdateImgId(id) {
      this.updateImgId = id;
    },
    beforeAvatarUpload(file) {
      console.log(file);
      if (file.size / 1024 / 1024 > 4) {//仅支持4mb
        this.$message.error(this.$t('message.titleBlockImg.bigImg'));
        return false;
      };
      let AllImg = ['image/jpeg', 'image/gif', 'image/png', 'image/bmp'];//仅支持图片格式
      if (AllImg.indexOf(file.type) == -1) {
        this.$message.error(this.$t('message.titleBlockImg.notImg'));
        return false;
      };

      let vm = this;
      let change_info = {};
      let imglist = ["isChange", "isManufacturer", "isManufacturerPart", "isQuality", "isTechnology", "isResource", "isProject", "isUser", "isUserGroup"];

      if (this.$store.state.isItemTitleBlockImg == "isItem") {
        change_info.changeId = this.$store.state.change_info.changeId;
        change_info.id = this.$store.state.objectId.id;
        change_info.classId = this.$store.state.objectId.classId;
        change_info.subClassId = this.$store.state.objectId.subClassId;
      } else if (imglist.includes(this.$store.state.isItemTitleBlockImg)) {
        change_info.changeId = 0;
        change_info.id = this.$store.state.objectId.id;
        change_info.classId = this.$store.state.objectId.classId;
        change_info.subClassId = this.$store.state.objectId.subClassId;
      } else {
        change_info.id = this.$store.state.redLineTitleBlockImg.id;
        change_info.classId = this.$store.state.redLineTitleBlockImg.classId;
        change_info.subClassId = this.$store.state.redLineTitleBlockImg.subClassId;
        change_info.changeId = 0;
      };

      var path = window.sessionStorage.getItem("tenantName") + '/icons/' + change_info.classId + '/' + change_info.subClassId +
        '/' + change_info.id + '/' + change_info.changeId + '/' + file.name;
      //console.log(path);

      let fd = new FormData();
      fd.append('fileName', file.name);
      fd.append('fileSize', file.size);
      fd.append('path', path);

      let fileImg = {
        id: this.updateImgId,
        parentId: change_info.id,
        parentClassId: change_info.classId,
        parentSubclassId: change_info.subClassId,
        parentChangeId: change_info.changeId,
        iconName: file.name,
        iconPath: path,
      };

      axios.post('/swift-file/icons/uploadIconUrl', fd).then(function (res) {
        console.log(res);
        if (res.data.object.code == 501) {
          vm.$confirm(vm.$t('message.confirm.overwrite'), vm.$t('message.tips.tip'), {
            confirmButtonText: vm.$t('message.button.affirm'),
            cancelButtonText: vm.$t('message.button.cancel'),
            type: 'warning'
          }).then(() => {
            vm.updateFile(file, fileImg, res.data.object.url);
          }).catch(() => {
            vm.$message({
              type: 'info',
              message: vm.$t('message.tips.deleteCancel')
            });
          });
        } else if (res.data.object.code == 200) {
          vm.updateFile(file, fileImg, res.data.object.url);
        } else {
          vm.$message.error(res.data.object.message);
          return false;
        };
      });
    },
    updateFile(file, fd, url) {
      let vm = this;
      this.upLoadDialog = true; //展示进度条
      var reopt = {
        method: "PUT",
        url: url,
        withCredentials: false,
        headers: { 'Content-Type': 'application/octet-stream' },
        validateStatus: function (status) {
          return status >= 200;
        },
        onUploadProgress: (progressEvent) => {
          console.log(progressEvent);
          if (progressEvent.lengthComputable) {
            var complete = (((progressEvent.loaded / progressEvent.total) * 100) | 0);
            vm.upLoadProgress = complete;
            console.log(vm.upLoadProgress);
            if (complete >= 100) {
              vm.upLoadDialog = false;
              vm.upLoadProgress = 0; // 重新置0
            };
          }
        },
        maxRedirects: 0,
        data: file,
      };
      axios.request(reopt).then(function (response) {
        if (response.status = 200) {
          axios.post('/swift-file/icons/uploadIconMetadata', fd).then(function (res) {
            // console.log(res);
            if (res.data.code == 200) {
              vm.$message({
                message: vm.$t('message.success.upLoad'),
                type: 'success'
              });
              vm.getIconImg();
            }
          });
        } else {
          console.log('Creating object using temporary signature failed!');
          console.log('status:' + response.status);
          console.log('\n');
        };
        console.log(response);
        console.log('\n');
      }).catch(function (err) {
        console.log('Creating object using temporary signature failed!');
        console.log(err);
        console.log('\n');
      });
    },
    getIconImg() {
      let vm = this;
      this.imageUrl = [],
        this.addNewFile = false;
      let change_info = {};
      console.log(this.$store.state);
      let imglist = ["isChange", "isManufacturer", "isManufacturerPart", "isQuality", "isTechnology", "isResource", "isProject", "isUser", "isUserGroup"];
      if (this.$store.state.isItemTitleBlockImg == "isItem") {
        change_info.changeId = this.$store.state.change_info.changeId;
        change_info.id = this.$store.state.objectId.id;
        change_info.classId = this.$store.state.objectId.classId;
        change_info.subClassId = this.$store.state.objectId.subClassId;
      } else if (imglist.includes(this.$store.state.isItemTitleBlockImg)) {
        change_info.changeId = 0;
        change_info.id = this.$store.state.objectId.id;
        change_info.classId = this.$store.state.objectId.classId;
        change_info.subClassId = this.$store.state.objectId.subClassId;
      } else {
        change_info.id = this.$store.state.redLineTitleBlockImg.id;
        change_info.classId = this.$store.state.redLineTitleBlockImg.classId;
        change_info.subClassId = this.$store.state.redLineTitleBlockImg.subClassId;
        change_info.changeId = 0;
      };

      var getFile = {
        parentId: change_info.id,
        parentClassId: change_info.classId,
        parentSubclassId: change_info.subClassId,
        parentChangeId: change_info.changeId,
      };
      axios.get(`swift-file/icons/getIconsDownloadUrl${this.params(getFile)}`).then(res => {
        console.log(res);
        if (res.data.object.length) {
          vm.imageUrl = res.data.object;
          vm.addNewFile = res.data.object.length < 5;
        } else {
          vm.addNewFile = true;
        };
      }).catch(_ => { })
    },

    loadUserPriv() {
      var priv_ = this.getUserContextPriv();
      // console.log(priv_);
      let subClass_Id = this.$store.state.objectId.subClassId;
      // console.log(subClass_Id);
      for (let i = 0; i < priv_.length; i++) {
        if (priv_[i].classId == subClass_Id) {
          // console.log(priv_[i]);
          if (priv_[i].type == 3) {
            this.updateRev = true;
          };
        }
      };

      let isSupAdmin = this.$store.state.isSuperAdmin;
      if (isSupAdmin) {
        this.updateRev = true;
      };
    },

  },
  computed: {
    reloadProjectBtnPrv() {
      return this.$store.state.change_info;
    },
  },
  watch: {
    reloadProjectBtnPrv: {
      handler(val) {
        this.getIconImg();
      },
      deep: true,
      // immediate: true,
    },
  },
  created() {
    this.getIconImg();
    this.loadUserPriv();
  },
}
</script>
<style>
.titleBlockImg .el-carousel__arrow--left {
  /* border-radius: 0 50% 50% 0; */
  top: 40%;

}

.titleBlockImg .el-carousel__arrow--right {
  /* border-radius: 50% 0 0 50%; */
  top: 40%;

}

.titleBlockImg .el-carousel__arrow {
  height: 50px;
  width: 50px;
  font-size: 18px;
}

.titleBlockImg .el-carousel__indicator.is-active button {
  opacity: 1;
  background: #4b92fe;
  height: 18px;
}

.titleBlockImg h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 150px;
  margin: 0 auto;
}

.titleBlockImg .el-carousel__button {
  width: 8px;
  height: 8px;
  background: #9a9a9a;
  border-radius: 2px;
}

.titleBlockImg .el-carousel__container {
  height: 240px !important;
}

.titleBlockImg .el-carousel__item {
  background-color: #fff;
}

.titleBlockImg .avatar-uploader {
  /* margin-left: 120px; */
}

.titleBlockImg .avatar-uploader .el-upload {
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.titleBlockImg .upLoadBorder .el-upload {
  border: 1px dashed #d9d9d9;
}

.titleBlockImg .avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.titleBlockImg .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 320px;
  height: 196px;
  line-height: 196px;
  text-align: center;
}

.titleBlockImg .avatar {
  width: 320px;
  height: 196px;
  display: block;
}
</style>

<style scoped>
.del:hover .del-icon {
  opacity: 1;
}

.del-icon {
  /* margin-left: auto;
  margin-right: 25px; */
  position: absolute;
  transition: 0.4s;
  opacity: 0;
  right: 6%;
  top: 6%;
  width: 26px;
  height: 26px;
  color: #fff;
  background: rgba(31, 45, 61, .2);
  padding-top: 6px;
  text-align: center;
  border-radius: 99px;
  box-sizing: border-box;
  cursor: pointer;
  z-index: 99;
}
</style>
